/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILiquidScriptData } from './liquid-script.data';
import { ILiquidScriptProps } from './liquid-script.props.autogenerated';

export interface ILiquidScriptViewProps extends ILiquidScriptProps<ILiquidScriptData> {

    scriptSource: string;
    identifier: string;
}

/**
 *
 * LiquidScript component
 * @extends {React.PureComponent<ILiquidScriptProps<ILiquidScriptData>>}
 */
class LiquidScript extends React.PureComponent<ILiquidScriptProps<ILiquidScriptData>> {
    public render(): JSX.Element | null {

        const { config } = this.props;

        const ScriptSource = config.scriptSource ? config.scriptSource : 'No Content';
        const Identifier = config.identifier ? config.identifier : 'No Content';

        const viewprops = {
            ...this.props,
            scriptSource: ScriptSource,
            identifier: Identifier,
            
        };
        return this.props.renderView(viewprops);
    }
}

export default LiquidScript;
